import styled from "styled-components";
import Typography from "../Typography";

export interface IStyledEditorLabel {
  bold?: boolean;
  fontSize?: string;
};

export const StyledLabel = styled(Typography)<IStyledEditorLabel>`
  ${({ theme, bold, fontSize }) => `
    font-size: ${fontSize === 'small' ? `${theme.uptimeFontSizes.desktop.fz4}px` : `${theme.uptimeFontSizes.desktop.fz5}px`};
    font-weight: ${bold ? 'bold' : 'normal'};
    line-height: ${theme.uptimeLineHeights.desktop.lh4}px !important;
    margin-bottom: ${theme.uptimeSpace[4]}px;
    color: ${theme.uptimeColors.textColors.primary};
  `}
`;

export const StyledReactQuill = styled.div`
  ${({ theme }) => `
    .ql-picker-options{
      padding: ${theme.uptimeSpace[5]}px;
      line-height: 1;
    }
    .ql-container {
      height: 100px;
    }
  `}
`;